import { useState, useEffect } from "react";
import { Link as ReachLink, useNavigate } from "react-router-dom";
import {
  Link,
  Button,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Spinner,
  Box,
  Heading,
  Text,
  FormControl,
} from "@chakra-ui/react";
import { EmailIcon, LockIcon, ViewOffIcon, ViewIcon } from "@chakra-ui/icons";
import UserPool from "../../UserPool";

const SignUp = () => {
  const [errorText, setErrorText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    if (errorText) {
      setErrorText("");
    }
  }, [email, password]);

  const handleShowPwd = () => setShowPwd(!showPwd);

  const onSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    UserPool.signUp(email, password, [], null, (err, data) => {
      if (err) {
        console.log(err.message);
        setIsLoading(false);
        setErrorText(err.message);
      } else {
        console.log(data);
        setIsLoading(false);
        if (data) {
          navigate("verification", {
            state: { userData: JSON.stringify(data), replace: true },
          });
        }
      }
    });
  };

  return (
    <Box>
      <Heading mb={4}>Register</Heading>
      <Text fontSize="xl" mt={6} mb={2}>
        Please sign up with your publicis sapient email
      </Text>
      <form onSubmit={onSubmit}>
        <FormControl>
          <InputGroup mt={2} mb={2}>
            <InputLeftElement
              pointerEvents="none"
              children={<EmailIcon />}
              color="gray"
            />
            <Input
              type="email"
              placeholder="Enter Email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </InputGroup>
        </FormControl>

        <FormControl>
          <InputGroup mt={2} mb={2}>
            <InputLeftElement
              pointerEvents="none"
              children={<LockIcon />}
              color="gray"
            />

            <Input
              type={showPwd ? "text" : "password"}
              placeholder="Enter Password "
              value={password}
              onChange={(event) => setPassword(event.target.value)}
            />
            <InputRightElement
              children={
                showPwd ? (
                  <ViewIcon color="gray" onClick={handleShowPwd} />
                ) : (
                  <ViewOffIcon color="gray" onClick={handleShowPwd} />
                )
              }
            />
          </InputGroup>
        </FormControl>

        <Button
          mt={2}
          mb={2}
          type="submit"
          size="sm"
          colorScheme="blue"
          disabled={isLoading || email.length === 0 || password.length === 0}
        >
          {isLoading && <Spinner size="sm" mr={2} />}
          Sign Up
        </Button>
        <Text fontSize="xs" color="red">
          {errorText}
        </Text>
      </form>
      <Text mt={6}>
        Already Signed up?
        <br />
        <Link as={ReachLink} to="/">
          Sign In
        </Link>
      </Text>
    </Box>
  );
};

export default SignUp;
